<template>
  <div class="wrapper">
    <ul class="timeSel">
      <li v-for="(item,index) in date" :key="index" @click="handleTab(index)" :class="current == index?`list_xuan`:` `">
        <span>{{ item.week }}</span>
        <span style="letter-spacing: 0px">{{ item.day }}</span>
      </li>
      <!-- <li @click="handleTab(1)" :class="current == 1?`list_xuan`:` `">
        <span>周日</span>
        <span><span style="letter-spacing: 0px">12</span>月<span style="letter-spacing: 0px">04</span>日</span>
        <span :class="current == 1?`selectTriangle`:` `"></span>
      </li> -->
    </ul>
    <ul class="cltime">
      <li @click="go">
        <span class="time">18:00~19:00</span>
        <span class="number">剩余号源:<span style="letter-spacing: 0px">157</span></span>
        <span class="guahao">
          <span v-if="num == 0">挂满</span>
          <span v-if="num != 0" style="color: orange">可挂号</span>
        </span>
      </li>
      <li>
        <span class="time">18:00~19:00</span>
        <span class="number">剩余号源:<span style="letter-spacing: 0px">157</span></span>
        <span class="guahao">挂满</span>
      </li>
      <li>
        <span class="time">18:00~19:00</span>
        <span class="number">剩余号源:<span style="letter-spacing: 0px">157</span></span>
        <span class="guahao">挂满</span>
      </li>
    </ul>
    <div class="select_people">
      <span class="sel_title">选择就诊人：</span>
      <span class="sel_name" v-for="item in columns" :key="item.carId" @click="selectren(item)">
        <span>{{ item.patientname }}</span>
        <img v-if="item.patientname == selectdata.patientname" src="@/assets/remind/select.png">
      </span>
      <span class="sel_add" @click="go2">添加就诊人</span>
    </div>
  </div>
</template>

<script>
import { selectVisitinfos } from "@/request/api.js";
export default {
  data() {
    return {
      columns: [],
      selectdata: {},
      current: 0,
      num: 157,
      date: []
    }
  },
  created() {
    this.getVisitinfos()
    this.getDate()
  },
  methods: {
    // 获取时间
    getDate(){
      for(let i=0;i<7;i++){
        let str = this.$moment().add(i,'days').format('dddd,MM.DD');
        let ary = str.split(",");
        let wk = "";
        switch (ary[0]) {
          case "Monday":
            wk = '周一'
            break;
          case "Tuesday":
            wk = '周二'
            break;
          case "Wednesday":
            wk = '周三'
            break;
          case "Thursday":
            wk = '周四'
            break;
          case "Friday":
            wk = '周五'
            break;
          case "Saturday":
            wk = '周六'
            break;
          case "Sunday":
            wk = '周日'
            break;
          default:
            break;
        }
        if(i==0){
          this.date.push({week: '今天',day: ary[1]})
        } else {
          this.date.push({week: wk,day: ary[1]})
        }
      }
    },
    // 获取所有就诊人
    async getVisitinfos() {
      let openid = sessionStorage.getItem("openid");
      let res = await selectVisitinfos({ openid });
      this.columns = res.data.obj;
      res.data.obj.forEach(item => {
        item.text = item.patientname;
        if (item.style == 1) {
          this.selectdata = item;
        }
      });
    },
    selectren(item){
      this.selectdata = item;
    },
    handleTab(value){
      this.current = value
    },
    go(){
      this.$router.push("/payment")
    },
    go2(){
      this.$router.push("/AddVisitors")
    }
  },
}
</script>

<style lang="less" scoped>
.wrapper{
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #f8f8f8;
  .timeSel{
    display: flex;
    flex-flow: row nowrap;
    // background: #fff;
    color: #888;
    border-bottom: 2px solid #ddd;
    height: 70px;
    font-size: 12px;
    letter-spacing: 1px;
    >li{
      position: relative;
      flex: 1;
      display: flex;
      flex-flow: column nowrap;
      text-align: center;
      height: 100%;
      justify-content: center;
      >span:nth-child(1){
        letter-spacing: 1px;
        margin-bottom: 8px;
      }
      .selectTriangle{
        transition: all .6s;
        position: absolute;
        width: 32px;
        height: 5px;
        left: calc(50% - 16px);
        bottom: 2px;
        background: #1C96CB;
        border-radius: 3px;
        margin: 0px !important;
      }
    }
    .list_xuan{
      transition: all .6s;
      color: rgb(81, 203, 255);
    }
  }
  .cltime{
    background: #fff;
    display: flex;
    flex-flow: column nowrap;
    font-weight: bold;
    font-size: 14px;
    border-bottom: 1px solid #ddd;
    >li{
      padding: 10px;
      display: flex;
      flex-flow: row nowrap;
      position: relative;
      .time{
        flex: 3;
        position: relative;
        top: 2px;
      }
      .number{
        letter-spacing: 1px;
      }
      .guahao{
        letter-spacing: 1px;
        flex: 1;
        text-align: right;
        color: #999;
      }
    }
  }
  .select_people{
    background: #fff;
    letter-spacing: 1px;
    display: flex;
    flex-flow: column nowrap;
    >span{
      padding: 10px;
    }
    .sel_title{
      color: #888;
    }
    .sel_name{
      position: relative;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      font-weight: bold;
      font-size: 14px;
      >img{
        position: relative;
        top: 1px;
      }
    }
    .sel_add{
      color: #0076a8;
      font-size: 12px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Index/nucleicTest.vue